import { render, staticRenderFns } from "./ModifyThresholdDetectionPopup.vue?vue&type=template&id=6708b9d3&"
import script from "./ModifyThresholdDetectionPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyThresholdDetectionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports